import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from "jquery"


@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

 
  constructor(private _router:Router ) { }

  ngOnInit() {
    
    $(document).ready(function(){

      $("body").on("click",".fa-bars",function(){
        $(this).removeClass("fa-bars").addClass("fa-times") ; 
        $(".con-ul").css("display","block")
      });
      
      $("body").on("click",".fa-times",function(){
        $(this).removeClass("fa-times").addClass("fa-bars") ; 
        $(".con-ul").css("display","none")
      });
    });

   
  }
  
  gotomovies()
  {
    var search = " "
    this._router.navigate(["/Movie/Search/",search])
  }
  
  
}
